export default __webpack_public_path__ + "static/media/screenShot_Rooms.3d6f443f.png";